import styled from "styled-components";

export const Container = styled.div`
  display: flex;
  gap: 0.5rem;
  flex-direction: column;
`;
export const LabelContainer = styled.div`
  display: flex;
  justify-content: space-between;

  span {
    font-size: 13px;
    text-transform: uppercase;
    font-family: var(--font-workSans);
  }
`;

export const ContainerProgress = styled.div`
  height: 11px;
  width: 280px;
  background-color: #d8d8d8;
  border-radius: 20px;
  border: 2px solid black;
`;
export const ProgressDone = styled.div`
  background-color: var(--color-yellow);
  box-shadow: 0 3px 3px -5px var(--color-white), 0 0.5px 5px var(--color-yellow);
  color: var(--bg-primary);
  font-weight: bold;
  height: 100%;
  width: ${(props) => props.width}%;
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 20px;
  -webkit-animation: scale-up-hor-left 0.4s cubic-bezier(0.39, 0.575, 0.565, 1)
    both;
  animation: scale-up-hor-left 1s cubic-bezier(0.39, 0.575, 0.565, 1) both;

  @-webkit-keyframes scale-up-hor-left {
    0% {
      -webkit-transform: scaleX(0.4);
      transform: scaleX(0.4);
      -webkit-transform-origin: 0% 0%;
      transform-origin: 0% 0%;
    }
    100% {
      -webkit-transform: scaleX(1);
      transform: scaleX(1);
      -webkit-transform-origin: 0% 0%;
      transform-origin: 0% 0%;
    }
  }
  @keyframes scale-up-hor-left {
    0% {
      -webkit-transform: scaleX(0.4);
      transform: scaleX(0.4);
      -webkit-transform-origin: 0% 0%;
      transform-origin: 0% 0%;
    }
    100% {
      -webkit-transform: scaleX(1);
      transform: scaleX(1);
      -webkit-transform-origin: 0% 0%;
      transform-origin: 0% 0%;
    }
  }
`;
